import React from "react";
import { ApolloProvider } from "@apollo/client";
import { guest } from "@utils/apoloClient";
import { Outlet } from "react-router-dom";

function GuestLayout() {
  return (
    <ApolloProvider client={guest}>
      <Outlet />
    </ApolloProvider>
  );
}

export default GuestLayout;
